import React from "react";
import { Box, InputAdornment, TextField, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
import { ClockIcon } from "../../../common/Icons/Icons";

const TimePicker = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Time Picker
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Browser Default time picker in basic outlined TextField."}
          language={"js"}
          value={
            "           <TextField\n" +
            '            label={"Don\'t send any messages before"}\n' +
            '            type={"time"}\n' +
            '            // value={"01:05"}\n' +
            "            InputProps={{\n" +
            "              endAdornment: (\n" +
            '                <InputAdornment position="end">\n' +
            "                  <ClockIcon />\n" +
            "                </InputAdornment>\n" +
            "              ),\n" +
            "            }}\n" +
            "            sx={{\n" +
            '              "& input::-webkit-calendar-picker-indicator": {\n' +
            '                width: "82%",\n' +
            '                position: "absolute",\n' +
            '                cursor: "pointer",\n' +
            "                opacity: 0,\n" +
            "                zIndex: 99,\n" +
            "              },\n" +
            "            }}\n" +
            "          />"
          }
        >
          <TextField
            label={"Don't send any messages before"}
            type={"time"}
            // value={"01:05"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <ClockIcon />
                </InputAdornment>
              ),
            }}
            sx={{
              "& input::-webkit-calendar-picker-indicator": {
                width: "82%",
                position: "absolute",
                cursor: "pointer",
                opacity: 0,
                zIndex: 99
              },
            }}
          />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default TimePicker;
